import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Row,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../components/FormContainer";
import { addNewDrug, updateRoot } from "../actions/drugActions";
import Loader from "../components/Loader";
import Message from "./Message";
import { listTags } from "../actions/tagActions";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FaCar, FaMoon, FaSun } from "react-icons/fa";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import DrugMoveTrade from "./DrugMoveTrade";

const DrugForm = ({ title, reqTrade }) => {
  const [rootId, setRootId] = useState();
  const [label, setLabel] = useState("");
  const [tradeLabels, setTradeLabels] = useState([{ idx: 1, label: "" }]);
  const [tags, setTags] = useState([{ idx: 0, tag: "" }]);
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [selectedTrade, setSelectedTrade] = useState("");

  const dispatch = useDispatch();

  const newDrugStore = useSelector((state) => state.newDrugStore);
  const { loading, drug: addedDrug } = newDrugStore;

  const rootByTradeIdStore = useSelector((state) => state.rootByTradeIdStore);
  const { drug: drugRoot } = rootByTradeIdStore;

  const updateRootStore = useSelector((state) => state.updateRootStore);
  const { loading: loadingUpdatedRoot, drug: updatedRoot } = updateRootStore;

  const tagListStore = useSelector((state) => state.tagListStore);
  const { tagList, noRequest: noTagRequest } = tagListStore;

  const handleTradeLabel = (e, trade) => {
    trade.label = e.target.value;
  };

  const addTradeRow = () => {
    setTradeLabels([...tradeLabels, { idx: Math.random(), label: "" }]);
  };

  const hideTradeName = (trade) => {
    trade.isHide = true;
  };

  const showTradeRow = (trade) => {
    trade.isHide = false;
  };
  const handleTags = (e, t) => {
    if (e.length > 0) {
      t.tag = e[0]._id;
    }
  };

  const addTagRow = () => {
    setTags([...tags, { idx: Math.random(), tag: "" }]);
  };
  const deleteTagRow = (t) => {
    setTags(tags.filter((ts) => ts !== t));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(addNewDrug({ label, tradeLabels, tags }));
  };

  const updateHandler = (e) => {
    e.preventDefault();
    dispatch(updateRoot({ _id: rootId, label, tradeLabels, tags }));
  };

  const moveTradeNameHandler = (trade) => {
    setSelectedTrade(trade);
    setShow(true);
  };

  // --- Effects ---

  useEffect(() => {
    if (drugRoot) {
      setRootId(drugRoot._id);
      setLabel(drugRoot.label);
      setTradeLabels(drugRoot.tradeLabels || [{ idx: 1, label: "" }]);
      setTags(drugRoot.tags || [{ idx: 0, tag: "" }]);
    }

    if (noTagRequest) {
      dispatch(listTags());
    }
    if (addedDrug) {
      setMessage("Drug added");
    }
    if (updatedRoot) {
      setMessage("Drug updated");
    }
  }, [drugRoot, noTagRequest, addedDrug, updatedRoot, dispatch]);

  return (
    <FormContainer>
      {reqTrade && !rootId ? (
        <Loader />
      ) : (
        <>
          <DrugMoveTrade
            show={show}
            setShow={setShow}
            selectedTrade={selectedTrade}
            setSelectedTrade={setSelectedTrade}
            selectedTradeRootId={rootId}
          />
          <Form>
            <h1 className="row justify-content-center">{title}</h1>
            <FormGroup controlId="label">
              <FormLabel>Drug Root Name</FormLabel>
              <FormControl
                type="text"
                placeholder="e.g.: Paracetamol"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
              />
            </FormGroup>

            <Form.Label>Trade Labels</Form.Label>
            {tradeLabels.map((trade) => (
              <Row key={trade.idx} className="mb-2">
                <Col className="col-8">
                  <FormGroup>
                    <Form.Control
                      style={{
                        textDecoration: trade.isHide ? "line-through" : "none",
                      }}
                      type="text"
                      placeholder="e.g.: Paramol 500 mg tab"
                      defaultValue={trade.label}
                      onChange={(e) => handleTradeLabel(e, trade)}
                    />
                  </FormGroup>
                </Col>
                <Col className="col-4">
                  <Button
                    onClick={() => showTradeRow(trade)}
                    disabled={!trade.isHide}
                  >
                    <FaSun />
                  </Button>
                  {trade.idx !== 1 && (
                    <>
                      <Button
                        className="btn-secondary ml-1"
                        onClick={() => hideTradeName(trade)}
                        disabled={trade.isHide}
                      >
                        <FaMoon />
                      </Button>
                      <Button
                        className="btn-info ml-1"
                        onClick={() => moveTradeNameHandler(trade)}
                      >
                        <FaCar />
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            ))}
            <Row>
              <Col>
                <Button
                  className="btn btn-block btn-secondary my-5"
                  onClick={addTradeRow}
                >
                  ADD NEW TRADE NAME
                </Button>
              </Col>
            </Row>

            <Form.Label>Drug Tags</Form.Label>
            {tagList &&
              tags.map((t) => (
                <Row key={t.idx} className="mb-2">
                  <Col className="col-sm-9">
                    <Typeahead
                      placeholder="Enter Medication Tag"
                      defaultInputValue={
                        t.tag && tagList?.find((tl) => tl._id === t.tag)?.label
                      }
                      options={tagList || []}
                      labelKey="label"
                      onChange={(e) => handleTags(e, t)}
                      id={`tag-${t.idx}`}
                    />
                  </Col>
                  {t.idx !== 0 && (
                    <Col className="col-sm-3">
                      <Button
                        onClick={() => deleteTagRow(t)}
                        className="font-weight-bold btn-danger"
                      >
                        -
                      </Button>
                    </Col>
                  )}
                </Row>
              ))}

            <Row className="row justify-content-end">
              <Button onClick={addTagRow} className="font-weight-bold">
                +
              </Button>
            </Row>

            <Row className="py-3 justify-content-end mr-2">
              {drugRoot ? (
                <Button onClick={updateHandler}>Update</Button>
              ) : (
                <Button onClick={submitHandler}>Submit New Drug</Button>
              )}
            </Row>
          </Form>
        </>
      )}
      {loading && <Loader />}
      {loadingUpdatedRoot && <Loader />}
      {message && (
        <Message children={message} variant="success" setMessgae={setMessage} />
      )}
    </FormContainer>
  );
};

export default DrugForm;
